import { useGeneratedApiClients } from '@/api/client'

// Single hook to get all API clients
export const useAPIClient = () => {
  return useGeneratedApiClients()
}